import React, { useEffect } from "react";
import { QURAN_SURAH } from "../../classes/UserProgress";

interface SurahVerseSelectorProps {
  fromSurah: number;
  fromVerse: number;
  toSurah: number;
  setToSurah: (value: number) => void;
  toVerse: number;
  setToVerse: (value: number) => void;
}

const SurahVerseSelector: React.FC<SurahVerseSelectorProps> = ({
  // lastProgressVerseInfo,
  fromSurah,
  fromVerse,
  toSurah,
  setToVerse,
  toVerse,
  setToSurah,
}) => {
  const lastSurah = fromSurah || 1;
  const lastVerse = fromVerse || 1;

  console.log("lastSurah", lastSurah);
  console.log("lastVerse", lastVerse);

  useEffect(() => {
    setToSurah(lastSurah);
    setToVerse(lastVerse);
  }, [fromSurah, fromVerse]);

  const getSurahByNumber = (number: number) =>
    QURAN_SURAH.find((surah: any) => surah.number === number);

  return (
    <div className="w-full flex flex-col gap-4 px-6 bg-white rounded-[2.4em] py-6">
      {/* Last Completed Surah & Verse */}
      <div>
        <h2 className="font-grgrifter tracking-wider text-2xl text-[#AFAEB3] mb-4">
          From
        </h2>
        <p className="text-lg font-bold">
          {getSurahByNumber(lastSurah)?.name || "Unknown"}, Verse {lastVerse}
        </p>
      </div>

      {/* To Surah & Verse Selection */}
      <div>
        <h2 className="font-grgrifter tracking-wider text-2xl text-[#AFAEB3] mb-4">
          To
        </h2>
        <div className="flex gap-2">
          <select
            className="border p-2 rounded-xl bg-[#efedf4]"
            value={toSurah}
            onChange={(e) => {
              const newSurah = parseInt(e.target.value);
              setToSurah(newSurah);
              setToVerse(1); // Reset verse when surah changes
            }}
          >
            {QURAN_SURAH.map((surah: any) => (
              <option key={surah.number} value={surah.number}>
                {surah.number === lastSurah
                  ? `📍 ${surah.name} (Last)`
                  : surah.name}
              </option>
            ))}
          </select>

          <select
            className="border p-2 rounded-xl bg-[#efedf4]"
            value={toVerse}
            onChange={(e) => setToVerse(parseInt(e.target.value))}
          >
            {Array.from(
              { length: getSurahByNumber(toSurah)?.ayahs || 1 },
              (_, i) => i + 1
            ).map((verse) => (
              <option key={verse} value={verse}>
                {toSurah === lastSurah && verse === lastVerse
                  ? `✅ Verse ${verse} (Last)`
                  : `Verse ${verse}`}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SurahVerseSelector;
